/**
 * Usage Service - Token usage analytics API
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://z6zx064ldk.execute-api.us-east-1.amazonaws.com/prod';

async function apiFetch(endpoint, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  const token = localStorage.getItem('authToken');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  let userEmail, userId;
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    userEmail = userInfo.email;
    userId = userInfo.userId || userInfo.sub;
  } catch (e) {}

  if (userEmail) headers['X-User-Email'] = userEmail;
  if (userId) headers['X-User-Id'] = userId;

  const url = `${API_BASE_URL}${endpoint}`;
  const response = await fetch(url, { headers, ...options });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error?.message || 'API request failed');
  }

  return data;
}

function buildQuery(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const usageService = {
  getMyUsage: () => apiFetch('/usage/me'),

  getSummary: (startDate, endDate) =>
    apiFetch(`/usage/summary${buildQuery(startDate, endDate)}`),

  getUsers: (startDate, endDate) =>
    apiFetch(`/usage/users${buildQuery(startDate, endDate)}`),

  getUserDetail: (userId, startDate, endDate) =>
    apiFetch(`/usage/users/${userId}${buildQuery(startDate, endDate)}`),

  getDaily: (startDate, endDate) =>
    apiFetch(`/usage/daily${buildQuery(startDate, endDate)}`),
};

export default usageService;
